import React, { useEffect, useState } from "react";
import AuthContext from "./context/userAuth.context";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Dasboard from "./dashboard.component/dashboardarea.component/dashboardarea.component";
import Editor from "./editor.component/Editor.Component";
import Login from "./login.component/login.component";
import { Switch, HashRouter } from "react-router-dom";
import PublicRoute from "./Utils/PublicRoute";
import DLoader from "./assets/Loader/mainLoader.json";
import "react-tippy/dist/tippy.css";
import PrivateRoute from "./Utils/PrivateRoute";
import axios from "axios";
import Loader from "./assets/Loader/loader.json";
import Lottie from "react-lottie";
import "./App.css";
import ForgotPassword from "./login.component/forgotpassword";
import ResetPassword from "./login.component/resetpassword";
import { AIJobsProvider } from "./AIStudio/AIJobsContext";

function App() {
  // node version 10.15.0 is compatible for this project Animatricks

  //const apiBaseurl = "http://RAIZEN/AnimationStudio2_API"; // Raheel pc

  const apiBaseurl = "https://app.toons.ai/AnimatricksAPI"; // live url

  //const apiBaseurl = "http://localhost/AnimatricksAPI"; // Local API

  const [Role, setRole] = useState(null);
  const [Access, setAccess] = useState(null);
  const [AllProject, setAllProject] = useState([]);

  const [categoriesProject, setcategoriesProject] = useState([]);
  const [DivName, setDivName] = useState("Dashboard");

  const [Tip, setTip] = useState({
    top: 0,
    Data: "any",
    show: false,
    left: 160,
  });

  //const Loader = require('./assets/Loader/loader.json')

  const [authenticationData, setAuthenticationData] = useState({
    authenticateData: {},
    ApiBaseURL: apiBaseurl,
    isAuthenticated: false,
  });

  const [authLoading, setAuthLoading] = useState(true);

  const [ExpiryCountdown, setExpiryCountdown] = useState(false);

  const [UserData, setUserData] = useState({});

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isChrome = /Chrome/.test(userAgent);
    const isFirefox = /Firefox/.test(userAgent);
    if (!isChrome && !isFirefox) {
      alert("Toons.AI is only supported for Chrome, Firefox and Opera.");
    }
  }, []);

  useEffect(() => {
    //authentication data will be set in 2 components.. 1 in here and other in login component
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    if (authData != null) {
      axios
        .get(authenticationData.ApiBaseURL + "/api/Account/CheckToken", {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        })
        .then((response) => {
          let expireIn_ms = parseInt(response.data.remainingTime);
          setTimeout(() => {
            setExpiryCountdown(true);
          }, expireIn_ms - 20000);
          let userObj = {
            email: response.data.email,
            userName: response.data.userName,
            id: response.data.User_Id,
          };
          setUserData(userObj);
          setRole(authData.Role);
          //console.log({accessLvl:authData.AccessLevel})
          setAccess(authData.AccessLevel);
          setAuthenticationData({
            authenticateData: authData,
            ApiBaseURL: apiBaseurl,
            isAuthenticated: true,
          });
          setAuthLoading(false);
        })
        .catch((error) => {
          localStorage.removeItem("animation_studio_2.0_access_token");
          setAuthenticationData({
            authenticateData: {},
            ApiBaseURL: apiBaseurl,
            isAuthenticated: false,
          });
          setAuthLoading(false);
        });
    } else {
      setAuthenticationData({
        authenticateData: {},
        ApiBaseURL: apiBaseurl,
        isAuthenticated: false,
      });
      setAuthLoading(false);
    }
  }, []);

  const clone = (obj) => {
    var copy;
    if (null == obj || "object" != typeof obj) return obj;
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = clone(obj[i]);
      }
      return copy;
    }
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  };

  const getLink = (isWatermark = false) => {
    if (Access === "US1") return "https://toons.ai/l/agency/";
    else if (Access === "US2") return "https://toons.ai/l/leadfinder/";
    else if (Access === "US3") return "https://toons.ai/l/monthlyupdates/";
    else if (Access === "FE" && isWatermark)
      return "https://toons.ai/l/agency/";
    else return "https://toons.ai/l/elite/";
  };

  return (
    <>
      <AuthContext.Provider
        value={{
          authenticationData,
          setAuthenticationData,
          apiBaseurl,
          Loader,
          AllProject,
          setAllProject,
          DivName,
          setDivName,
          Tip,
          setTip,
          clone,
          ExpiryCountdown,
          setExpiryCountdown,
          Role,
          setRole,
          categoriesProject,
          setcategoriesProject,
          UserData,
          setUserData,
          Access,
          setAccess,
          getLink,
        }}
      >
        {authLoading && (
          <>
            <div
              style={{
                width: "100%",
                height: "100%",
                background: "rgb(255 255 255 / 85%)",
                zIndex: "9999999",
                inset: "0px",
                position: "absolute",
              }}
            >
              <Lottie
                options={{ loop: true, autoplay: true, animationData: DLoader }}
                height={300}
                width={300}
                isStopped={false}
                style={{
                  width: "300px",
                  height: "300px",
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                isPaused={false}
              />
              <div
                style={{
                  position: "relative",
                  left: "51%",
                  top: "65%",
                  transform: "translate(-50%, -50%)",
                  display: "inline-block",
                }}
              >
                Processing, please wait.
              </div>
            </div>
          </>
        )}

        {!authLoading && (
          <HashRouter>
            {/* AI Studio: follows AI template generations on every page (progress, notifications). */}
            <AIJobsProvider>
            <Switch>
              <PublicRoute
                exact
                path="/"
                isAuthenticated={authenticationData.isAuthenticated}
                redirectPath="/dashboard"
                component={Login}
              />
              <PublicRoute
                exact
                path="/forgotpassword"
                component={ForgotPassword}
              />
              <PublicRoute
                exact
                path="/resetpassword"
                component={ResetPassword}
              />

              <PrivateRoute
                path="/editor"
                isAuthenticated={authenticationData.isAuthenticated}
                redirectPath="/"
                component={Editor}
              />

              <PrivateRoute
                path="/dashboard"
                isAuthenticated={authenticationData.isAuthenticated}
                redirectPath="/"
                component={Dasboard}
              />
            </Switch>
            </AIJobsProvider>
          </HashRouter>
        )}
      </AuthContext.Provider>
    </>
  );
}
export default App;
